import { useExportFile, useExportLogs } from "../custom-hooks/queries";
import { useEffect, useState } from "react";
import moment from "moment";
import SkeletonLoader from "./SkeletonLoader";
import Pagination from "./CustomPagination";
import Notification from "./Notification";

export default function HistoryTable() {
  const [currentPage, setCurrentPage] = useState(1);

  const { data, error, isError, isLoading, refetch } =
    useExportLogs(currentPage);
  const totalPages = data?.total_pages;
  const [show, setShow] = useState(false);

  const {
    mutate,
    data: res,
    isError: isFileError,
    error: errorMessageFile,
  } = useExportFile();

  useEffect(() => {
    refetch();
  }, [currentPage, refetch]);

  const formatDateTime = (dateTime) => {
    // Convert the date to local time and format it
    return moment.utc(dateTime).local().format("MM/DD/YYYY, h:mm A");
  };

  useEffect(() => {
    if (isFileError || isError) {
      setShow(true);
      return;
    }
    if (res?.download_link) {
      const link = document.createElement("a");
      link.href = res.download_link;
      link.download = "file.pdf"; // Set the filename (optional)
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }, [res, isFileError]);

  const handleExportFile = (id) => {
    mutate(id);
  };

  return (
    <div className="container w-full px-4 sm:px-6 lg:px-8 min-h-screen">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            Export History
          </h1>
          <p className="mt-2 text-sm text-gray-700">
            This is a history of exports from your account, You can download
            exports that are less than 30 days old.
          </p>
        </div>
      </div>
      {isLoading ? (
        <SkeletonLoader />
      ) : (
        <div className="mt-8 flow-root">
          <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block w-full py-2 align-middle sm:px-6 lg:px-8">
              <div className="overflow-x-auto shadow ring-1 ring-black ring-opacity-5">
                {/* Apply table-layout: fixed to the table */}
                <table className="min-w-full table-fixed divide-y divide-gray-300">
                  <thead className="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        className="w-1/5 px-3 py-3.5 text-center text-sm font-semibold text-gray-900"
                      >
                        Requested On
                      </th>
                      <th
                        scope="col"
                        className="w-1/5 py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-gray-900 sm:pl-6"
                      >
                        Export Type
                      </th>
                      <th
                        scope="col"
                        className="w-1/5 px-3 py-3.5 text-center text-sm font-semibold text-gray-900"
                      >
                        Number of Records
                      </th>
                      <th
                        scope="col"
                        className="w-1/5 px-3 py-3.5 text-center text-sm font-semibold text-gray-900"
                      >
                        Status
                      </th>
                      <th
                        scope="col"
                        className="w-1/5 px-3 py-3.5 text-center text-sm font-semibold text-gray-900"
                      >
                        Download
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white text-center">
                    {data?.items?.map((item) => (
                      <tr key={item.email}>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                          {formatDateTime(item?.request_date_time)}
                        </td>
                        <td className="whitespace-nowrap py-4 text-gray-500 pl-4 pr-3 text-sm sm:pl-6">
                          {item?.entity_type}
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                          {item?.total_number_of_records_processed}
                        </td>
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                          {item?.status}
                        </td>
                        <td
                          onClick={() => handleExportFile(item?.export_logs_id)}
                          className={`whitespace-nowrap px-3 py-4 text-sm ${
                            item?.status !== "Completed"
                              ? "text-gray-500 cursor-not-allowed"
                              : "text-custom-link-color cursor-pointer underline font-bold"
                          }`}
                        >
                          Download
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
      {!isError && !isLoading && (
        <div className="mt-5">
          <Pagination
            totalPages={totalPages}
            currentPage={currentPage}
            onPageChange={setCurrentPage}
          />
        </div>
      )}

      <Notification
        show={show}
        setShow={setShow}
        errorMessage={error ? error?.message : errorMessageFile?.message}
        status={"error"}
      />
    </div>
  );
}
